import { hotTopics } from "../../../mocks/trending";

export default function Topics() {
  return (
    <section id="topics" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-secondary-700">
              <i className="ri-message-3-line" /> 本周热议
            </span>
            <h2 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-4xl">
              大家都在聊什么
            </h2>
            <p className="mt-3 max-w-2xl text-foreground-600">
              从出圈现场到脑洞挑战，一起围观当下最有讨论度的热门话题，看看这场"瓜"里藏了多少精彩。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {hotTopics.map((t) => (
            <article
              key={t.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 sm:flex-row"
            >
              <div className="relative w-full overflow-hidden sm:w-52">
                <img
                  src={t.cover}
                  alt={`吃瓜爆网热议话题封面：${t.title}`}
                  title={`${t.title} 吃瓜爆网热门话题`}
                  loading="lazy"
                  className="aspect-[16/10] h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 sm:aspect-auto"
                />
              </div>
              <div className="flex flex-1 flex-col gap-2 p-5">
                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-semibold text-accent-800">
                    {t.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{t.posts}</span>
                </div>
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-900">
                  {t.title}
                </h3>
                <p className="line-clamp-2 text-sm text-foreground-600">
                  {t.desc}
                </p>
                <div className="mt-auto flex items-center justify-between pt-2">
                  <span className="inline-flex items-center gap-1 text-sm text-foreground-500">
                    <i className="ri-fire-fill text-primary-500" /> {t.reads}
                  </span>
                  <a
                    href="#faq"
                    className="inline-flex cursor-pointer items-center gap-1 text-sm font-semibold text-primary-600 hover:text-primary-700"
                  >
                    一起围观 <i className="ri-arrow-right-line" />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}